"use client";

import CopyIcon from "@/assets/icons/copy.svg";
import { formatAddress } from "@/shared/helpers";
import { handleCopyText } from "@/shared/utilities";
import { useState } from "react";
import { twMerge } from "tailwind-merge";

export interface Props {
  address: string;
  className?: string;
}

// TODO: hardcoded colors
const Address = ({ address, className }: Props) => {
  const [disabled, setDisabled] = useState(false);

  return (
    <button
      type="button"
      className={twMerge(
        "flex items-center justify-center h-10 px-3 gap-x-2 border-4 border-invert endemic:border-primary bg-endemicGray-100 night:bg-[#2A2A2A] rounded-3xl shadow-lg hover:cursor-pointer",
        className,
      )}
      onClick={() => handleCopyText(address, setDisabled)}
      disabled={disabled}
    >
      <CopyIcon className="w-3 h-3 fill-[#D60A51]" />
      <p className="text-sm font-light text-primary endemic:text-invert tracking-tight">
        {disabled ? "Copied" : formatAddress(address)}
      </p>
    </button>
  );
};

export default Address;
